const $header = $('.ds-header');
const $button = $('.ds-header__menu-button-mobile');
const $mobileMenu = $('mobile-menu');
const $mobileMenuLink = $('.mobile-menu__submenu-link');
let lastScrollTop = 0;

$(function () {
  $(window).on('scroll', function () {
    const scroll = $(window).scrollTop();

    if (scroll >= 128) {
      $header.addClass('scrolled');

      let st = $(this).scrollTop();

      if (st > lastScrollTop) {
        $header.removeClass('scroll-up').addClass('scroll-down');
      } else {
        $header.addClass('scroll-up').removeClass('scroll-down');
      }
      lastScrollTop = st;
    } else {
      $header.removeClass('scroll-up');
      $header.removeClass('scrolled');
    }
  });

  $button.on('click', function () {
    const $this = $(this);

    $this.toggleClass('active');
    $mobileMenu.toggleClass('active');
  });

  $mobileMenuLink.on('click', function () {
    $button.removeClass('active');
    $('.mobile-menu').removeClass('active');
  });
});
